import { call, put, takeLatest, all } from 'redux-saga/effects';
import { addPartnerActions as actions } from '.';
import { authenticatedPost } from 'remote/api';
import { PayloadAction } from '@reduxjs/toolkit';
export function* addPartnerSaga(action: PayloadAction<any>) {
  // yield takeLatest(actions.someAction.type, doSomething);
  try {
    const response = yield call(
      authenticatedPost,
      `${process.env.REACT_APP_API_URL}/groups/invites`,
      action.payload,
    );

    yield put(actions.inviteMemberSuccess(response.data));
  } catch (error: any) {
    yield put(actions.inviteMemberFailure(error.message));
  }
}

export function* watchaddPartnerSaga() {
  yield all([takeLatest(actions.inviteMember.type, addPartnerSaga)]);
}
